export const generateCustomEvent = (eventName: string, object = {}) => {
  const event = new CustomEvent(eventName, {
    detail: { ...object },
  })
  document.dispatchEvent(event)
}
